import { Router } from '@angular/router';

export class BaseIrrigation
{
    private baseRouter: Router;
    constructor(router: Router)
    {
        this.baseRouter = router;
    }

    goToDashboard(locationId: number, useCache: boolean)
    {
        this.baseRouter.navigate([`/dashboard/${locationId}/irrigation/main`], { queryParams: { useCache: useCache } });
    }

    goToControllersTab(locationId: number, useCache: boolean)
    {
        this.baseRouter.navigate([`/dashboard/${locationId}/irrigation/controllers`], { queryParams: { useCache: useCache } });
    }

    goToFirmwareManagement(locationId: number, useCache: boolean)
    {
        this.baseRouter.navigate([`/dashboard/${locationId}/firmware/`], { queryParams: { useCache: useCache } });
    }
}
